import React from 'react';
import { FaWater, FaDatabase, FaPercentage, FaChartBar, FaArrowRight } from 'react-icons/fa';
import '../styles/reservatorios.css';

import { useNavigate } from 'react-router-dom';
import { useFeatures } from '../../../hooks/useFeatures';

const DashboardSummary = ({ resumo, blocoId }) => {
  const navigate = useNavigate();
  const { hasAccessToFeature } = useFeatures();
  if (!resumo) return null;

  const { total_reservatorios, total_capacidade_litros, volume_atual_litros, nivel_medio_porcentagem } = resumo;

  return (
    <div className="dashboard-summary">
      <div className="summary-card">
        <div className="summary-icon primary">
          <FaDatabase />
        </div>
        <div className="summary-info">
          <span className="summary-title">Total de Tanques</span>
          <span className="summary-value">{total_reservatorios}</span>
        </div>
      </div>

      <div className="summary-card">
        <div className="summary-icon info">
          <FaWater />
        </div>
        <div className="summary-info">
          <span className="summary-title">Volume Atual (L)</span>
          <span className="summary-value">{volume_atual_litros.toLocaleString('pt-BR')}</span>
          <span className="summary-subtitle">de {total_capacidade_litros.toLocaleString('pt-BR')} Litros</span>
        </div>
      </div>

      <div className="summary-card">
        <div className="summary-icon success">
          <FaPercentage />
        </div>
        <div className="summary-info">
          <span className="summary-title">Retenção Geral</span>
          <span className="summary-value">{nivel_medio_porcentagem}%</span>
        </div>
      </div>

      {hasAccessToFeature('reservatorios_analytics') && (
        <button
          className="summary-card summary-action-card"
          type="button"
          onClick={() => navigate(`/reservatorios/bloco/analytics/${blocoId}`)}
        >
          <span className="bloco-analytics-btn__content">
            <span className="bloco-analytics-btn__icon">
              <FaChartBar />
            </span>
            <span className="bloco-analytics-btn__text">
              <span className="bloco-analytics-btn__label">Analytics do bloco</span>
            </span>
          </span>
          <span className="bloco-analytics-btn__arrow" aria-hidden="true">
            <FaArrowRight />
          </span>
        </button>
      )}
    </div>
  );
};

export default DashboardSummary;
